module.exports = __webpack_public_path__ + "img/flac.01c4bfff.png";